import React from "react";
import {Loader} from "@progress/kendo-react-indicators";

export const LoadingOverlay = () => (
    <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 999
    }}>
        <Loader size='large' type={'converging-spinner'} />
    </div>
);